<div class="space-y-5">

  <!-- Nearby Places -->
  <section class="rounded-2xl bg-white p-5 shadow-sm">

    <h3 class="mb-4 text-sm font-semibold text-gray-800">
      Nearby Places
    </h3>

    <div class="nearby-grid grid gap-3">

      <div
        *ngFor="let item of selectedItem?.nearbyPlaces"
        class="flex items-center gap-3 rounded-xl border border-gray-100 bg-gray-50/60 px-4 py-3"
      >

        <div
          class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-violet-50 text-violet-600"
        >
          <i class="fas fa-location-dot text-xs"></i>
        </div>

        <span class="text-sm font-medium text-gray-700">
          {{ item }}
        </span>

      </div>

    </div>

  </section>


  <!-- Living Environment -->
  <section
    *ngIf="selectedItem?.livingEnvironment?.length"
    class="rounded-2xl bg-white p-5 shadow-sm"
  >

    <h3 class="mb-4 text-sm font-semibold text-gray-800">
      Living Environment
    </h3>

    <div class="flex flex-wrap gap-2">

      <span
        *ngFor="let item of selectedItem.livingEnvironment"
        class="rounded-full border border-violet-100 bg-violet-50 px-3 py-1.5 text-xs font-medium text-violet-700"
      >
        {{ item }}
      </span>

    </div>

  </section>


  <!-- Location -->
  <section class="rounded-2xl bg-white p-5 shadow-sm">

    <div class="flex items-start gap-3">

      <div
        class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-violet-50 text-violet-600"
      >
        <i class="fas fa-location-dot text-sm"></i>
      </div>

      <div class="min-w-0 flex-1">

        <h3 class="mb-2 text-sm font-semibold text-gray-800">
          Location
        </h3>

        <p class="text-sm leading-6 text-gray-500">
          {{ formatAddress(selectedItem) || 'Address not available' }}
        </p>

      </div>

    </div>


    <div *ngIf="mapUrl" class="location-map mt-5">
      <iframe
        [src]="mapUrl"
        [title]="'Map of ' + formatAddress(selectedItem)"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        allowfullscreen
      ></iframe>
    </div>

    <a
      *ngIf="directionsUrl"
      [href]="directionsUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="mt-5 inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition hover:border-violet-300 hover:text-violet-600"
    >
      <i class="fas fa-directions"></i>
      Get Directions
    </a>

  </section>

</div>
